export { default } from './GlobalFooter'
